import { useState } from "react";

type Item = { time: string; cat: string; title: string; dek: string };

const cats = ["全部", "实锤", "独家", "内幕", "开撕", "反转"];

const items: Item[] = [
  { time: "07:42", cat: "独家", title: "顶流所属工作室连夜删了三条澄清博", dek: "删帖时间与某站爆料高度重合，网友扒出截图留档。" },
  { time: "08:15", cat: "内幕", title: "爆款古偶换角内幕：开机前一周才通知原定女二", dek: "知情人晒出群聊时间线，片方暂未回应。" },
  { time: "09:03", cat: "实锤", title: "热播综艺后期被指恶意剪辑某嘉宾发言", dek: "逐帧对比后，切掉的 11 秒成了新看点。" },
  { time: "10:26", cat: "开撕", title: "前队友互撕再升级，双方后援会同时下场", dek: "声明、录屏、转账截图轮番上，评论区彻底失守。" },
  { time: "11:50", cat: "实锤", title: "网红带货单品被送检，成分与宣传不符", dek: "检测机构出具报告，商家客服已读不回。" },
  { time: "13:08", cat: "独家", title: "选秀C位深夜直播连线，疑似哽咽吐苦水", dek: "三句话没说完就下播，粉丝已刷起话题。" },
  { time: "14:37", cat: "内幕", title: "综艺常驻嘉宾的档期「买断」价被圈内人晒出", dek: "多位制片人口径不一，仅一人愿实名背书。" },
  { time: "16:02", cat: "反转", title: "被锤「恋综剧本」的CP，正主深夜亲自回应", dek: "一句「我们本来就不是演的」把热度又抬高一截。" },
];

const catStyle: Record<string, string> = {
  实锤: "bg-primary-100 text-primary-800",
  独家: "bg-accent-100 text-accent-900",
  内幕: "bg-secondary-100 text-secondary-900",
  开撕: "bg-background-200 text-foreground-700",
  反转: "bg-foreground-950 text-background-50",
};

export default function DailyFeed() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? items : items.filter((i) => i.cat === active);

  return (
    <section id="feed" className="mt-16 bg-background-100/70 py-16 md:mt-20 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-[11px] tracking-[0.25em] text-primary-700 font-label">
              <i className="ri-broadcast-line text-accent-500 w-4 h-4 flex items-center justify-center" />
              每日看点 · 猛料速递
            </p>
            <h2 className="mt-2 font-serif text-3xl font-black text-foreground-950 md:text-4xl">
              今日份猛料，已送达
            </h2>
          </div>
          {/* filter tabs */}
          <div className="inline-flex max-w-full flex-wrap items-center gap-1 rounded-full bg-background-50 border border-background-300/60 p-1">
            {cats.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`rounded-full px-3.5 py-1.5 text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  active === c
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* feed list */}
          <div className="lg:col-span-8">
            <div className="divide-y divide-background-300/50">
              {list.map((it, idx) => (
                <a
                  key={it.title}
                  href="#feed"
                  className="group flex items-start gap-4 py-5 cursor-pointer"
                >
                  <span className="w-12 shrink-0 pt-1 text-sm font-serif font-bold text-foreground-400 tabular-nums">
                    {it.time}
                  </span>
                  <span
                    className={`mt-0.5 inline-flex shrink-0 items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium ${catStyle[it.cat]}`}
                  >
                    {it.cat}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                      {it.title}
                    </span>
                    <span className="mt-1 block text-sm text-foreground-600">{it.dek}</span>
                  </span>
                  <span className="hidden sm:inline-flex h-8 w-8 items-center justify-center rounded-full border border-background-300/70 text-foreground-400 opacity-0 transition-opacity group-hover:opacity-100">
                    <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center" />
                  </span>
                </a>
              ))}
              {list.length === 0 && (
                <p className="py-10 text-center text-sm text-foreground-500">
                  这一栏暂时没有更新，去别处吃口瓜吧。
                </p>
              )}
            </div>
            <p className="pt-2 text-xs text-foreground-400 font-label">
              已为您载入 {list.length} 条 · 每条约 40 秒读完 · 更新至今日 {items[items.length - 1].time}
            </p>
          </div>

          {/* slim sidebar summary */}
          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-300/60 bg-background-50 p-6">
              <p className="text-[11px] tracking-[0.2em] text-foreground-400 font-label">今日战报</p>
              <div className="mt-4 grid grid-cols-3 gap-3 text-center">
                {[
                  { num: "28", label: "更新条数" },
                  { num: "6", label: "独家首爆" },
                  { num: "4", label: "实锤落地" },
                ].map((s) => (
                  <div key={s.label} className="rounded-md bg-background-100 py-3">
                    <p className="font-serif text-2xl font-black text-foreground-950">{s.num}</p>
                    <p className="mt-1 text-[11px] text-foreground-500 font-label">{s.label}</p>
                  </div>
                ))}
              </div>
              <div className="mt-5">
                <p className="text-xs text-foreground-400 font-label">今日上榜 · 反转最多</p>
                <p className="mt-2 font-serif text-lg font-bold leading-snug text-foreground-900">
                  白天锤得越狠，
                  <br />
                  晚上反转越快。
                </p>
              </div>
              <a
                href="#heat"
                className="mt-5 inline-flex whitespace-nowrap w-full items-center justify-center gap-2 rounded-md border border-foreground-950 px-4 py-2.5 text-sm font-medium text-foreground-950 hover:bg-foreground-950 hover:text-background-50 transition-colors cursor-pointer"
              >
                回热度榜看排位变化
                <i className="ri-arrow-right-up-line text-base w-4 h-4 flex items-center justify-center" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}